import BaseModel from '../core/BaseModel'
export default class ImportBoxModel extends BaseModel {
    constructor() {
        super({ 
                name: "record_detail",
                tableName: 'record_detail', 
                label: "Danh sách nhập",
            },  
            {
                stt: { 
                    name: "stt",
                    label: "STT",
                    width : 5,
                    class: 'center',
                    computed: (data, index) => {
                        data.stt = index + 1;
                    }
                },
                id: { 
                    name: 'id', 
                    type: "Uuid", 
                    label: 'ID', 
                    primaryKey: true, 
                    display: false
                },
                record: {
                    refs: "record {id code}",
                    display: false
                },
                unit: {
                    refs: "unit {id code}",
                    display: false
                },
                obj_box: {
                    refs: "obj_box {id code}",
                    display: false
                },
                unit_code : { 
                    name: 'unit_code',
                    type: "String",
                    label: 'Mã Unit',
                    filter: {
                        type: 'input',
                        match: 'contains'
                    },
                    computed: (data) => {
                        data.unit_code = "";
                    }
                },
                box_code: {
                    name: 'box_code', 
                    type: "String", 
                    label: 'Mã hộp',
                    computed: (data) => {
                        data.box_code = "";
                    }
                }
            },
        )
    }

}